const userRequestGenerator = ({
  clinicGuid,
  maxCriticalSystolic,
  minCriticalSystolic,
  maxCriticalDiastolic,
  minCriticalDiastolic,
  maxCriticalPulse,
  minCriticalPulse,
  maxCriticalSleepPulse,
  minCriticalSleepPulse,
  maxCriticalGlucose,
  minCriticalGlucose,
  maxCriticalWeight,
  minCriticalWeight,
  maxRiskSystolic,
  minRiskSystolic,
  maxRiskDiastolic,
  minRiskDiastolic,
  maxRiskPulse,
  minRiskPulse,
  maxRiskSleepPulse,
  minRiskSleepPulse,
  maxRiskGlucose,
  minRiskGlucose,
  maxRiskWeight,
  minRiskWeight,
  criticalBloodoxygen,
  riskBloodoxygen,
  minRiskPef,
  minCriticalPef,
  minCriticalFev1,
}) => {
  const body = {
    clinicGuid,
    maxCriticalSystolic,
    minCriticalSystolic,
    maxCriticalDiastolic,
    minCriticalDiastolic,
    maxCriticalPulse,
    minCriticalPulse,
    maxCriticalSleepPulse,
    minCriticalSleepPulse,
    maxCriticalGlucose,
    minCriticalGlucose,
    maxCriticalWeight,
    minCriticalWeight,
    maxRiskSystolic,
    minRiskSystolic,
    maxRiskDiastolic,
    minRiskDiastolic,
    maxRiskPulse,
    minRiskPulse,
    maxRiskSleepPulse,
    minRiskSleepPulse,
    maxRiskGlucose,
    minRiskGlucose,
    maxRiskWeight,
    minRiskWeight,
    criticalBloodoxygen,
    riskBloodoxygen,
    minRiskPef,
    minCriticalPef,
    minCriticalFev1,
  };
  return body;
};
export default userRequestGenerator;
